'use es6';

import { DRAFT_KEY_PREFIX } from '../constants/draftKeyPrefix';
export const makeDraftKeyFromReplyId = replyId => `${DRAFT_KEY_PREFIX}_${replyId}`;